<template>
  <v-app class="mainApp">
    <v-main style="padding-top: 0px !important; margin-bottom: 50px">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-main>

    <Footer />
  </v-app>
</template>

<script>
import Footer from './footer';
export default {
  name: 'Layout',
  components: {
    Footer,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 12px 50px;
}

.mainApp {
  background-image: url(@/assets/image_bg_2.png) !important;
  background-size: cover !important;
}
</style>
